import { Unit } from '@ml/services/types/service';

export class TaskLogMeasurement {
  id?: number;
  unit: Unit;
  amount: number;
  supplierAmount: number;
  customerAmount: number;
}
